import React from "react"

export const mobOwn = (t) =>{ 
    const mobOwnData = [
    {
        capture:t( "price_item_description1"),
        description1:`min 30 ${t('price_days')}`,
        description2:`0 ${t('price_days')}`
    },
    {
        capture:t( "price_item_description2"),
        description1:`7-10 ${t('price_days')}`,
        description2:`0 ${t('price_days')}`
    },
    {
        capture:t( "price_item_description3"),
        description1:`From 3 to 6 ${t('price_month')}`,
        description2:`0 ${t('price_days')}`
    },
    {
        capture:t( "price_item_description4"),
        description1:'12/19% or 32%',
        description2:'6% or 12%'
    },
    {
        capture:t( "price_item_description5"),
        description1:'1000 zl',
        description2:'0 zl'
    },
    {
        capture:t( "price_item_description6"),
        description1:'400 zl',
        description2:'0 zl'
    },
    {
        capture:t( "price_item_description7"),
        description1:'800-1600 zl',
        description2:'0 zl'
    },
    {
        capture:t( "price_item_description8"),
        description1:`200zl/${t('price_hour')}`,
        description2:'-'
    },
    {
        capture:t( "price_item_description9"),
        description1:'500 zl',
        description2:'0 zl'
    },
    {
        capture:t( "price_item_description10"),
        description1:'3500 zl',
        description2:'0 zl'
    },
];
return mobOwnData
}

